import React from "react";
import { RiInstagramFill } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { FiClock } from "react-icons/fi";
import { Link } from "react-router-dom";


const Footer = () => {

    return (
        <footer className= "py-10 px-5 md:px-10 lg:px-20">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                <div>
                    <h2 className="text-3xl font-bold mb-4">
                    HARE KRISHNA TRADERS

                    </h2>
                    <p>
                    Glacier Treats, where every scoop is a taste of happiness! We bring you a wide selection of handcrafted ice creams,
                    made from the finest ingredients to ensure a rich, creamy, and unforgettable flavor.
                    </p>
                </div>

                <div>
                    <h3 className="text-3xl font-bold mb-4">Quick Links</h3>
                    <ul className="space-y-2">
                        <li><Link to="" className="hover:text-gray-500">Home</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Order</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Wallet</Link></li>
                        <li><Link to="" className="hover:text-gray-500">About us</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Contact us</Link></li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-3xl font-bold mb-4">Contact Us</h3>
                    <ul className="space-y-2">
                        <li>12/22, Koothanur, Mallikundam Road</li>
                        <li> Mecheri, Salem 636458</li>
                        <li>Email: jayaprakash892@gmail.com</li>
                        <li>Phone: 9787292119, 97899573268, 9790168814</li>
                        <li>GSTIN: 33CFYPM6838M1ZF | State: TamilNadu (33)</li>
                    </ul>
                   
                </div>
                <div>
                    <h3 className="text-3xl font-bold mb-4">Help</h3>
                    <ul className="space-y-2">
                        <li><Link to="" className="hover:text-gray-500">Privacy Policy</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Terms of Service</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Customer Service</Link></li>
                        <li><Link to="" className="hover:text-gray-500">Self Service</Link></li>
                    </ul>
                </div>
                <div className="">
                <h3 className="text-3xl font-bold mb-4">Follow Us</h3>

                <div className="flex space-x-4 pt-3">
                        <Link to="" className="hover:text-green-950"><SiGmail size={25} /></Link>
                        <Link to="" className="hover:text-green-400"><FaWhatsapp size={25} /></Link>
                        <Link to="" className="hover:text-[red]"><RiInstagramFill size={25} /></Link>
                        <Link to="" className="hover:text-blue-400"><FaFacebook size={25} /></Link>
                    </div>
                    <div className="pt-8">
                    <FiClock size={25} className="mb-4 text-gray-600" />

                        <h5>Mon-Fri: 9am-10pm</h5>
                        <h5>Sat: 10pm-4am</h5>
                        <h5>Sun: 10am-4pm</h5>
                    </div>
                </div>
            </div>

            <div className="mt-10 border-t border-gray-700 pt-5 text-center">
                <p>&copy; 2025 . All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;

